import { useEffect, useState } from "react";
import { queryOptions } from "@tanstack/react-query";

import { fetchUserPreferences } from "@lib/api/userPreferencesApi";
import { Auth } from "@lib/authentication/amplify/amplify";

export type { UserPreferences } from "@lib/api/userPreferencesApi";

export const getUserPreferencesQueryKey = (userId?: string) => [
  "user-preferences",
  userId,
];

export const useGetUserPreferencesQueryOptions = () => {
  // Resolve the sub directly from Amplify so the hook stays usable on public
  // routes where the AuthenticationProvider isn't mounted (e.g. Menu on
  // /gifts). Same pattern as the auth check in checkout.tsx.
  const [sub, setSub] = useState<string | undefined>();

  useEffect(() => {
    Auth.currentAuthenticatedUser().then((result) => {
      if (!result.success) return;
      setSub(result.data.authenticatedUser.sub);
    });
  }, []);

  return queryOptions({
    queryKey: getUserPreferencesQueryKey(sub),
    queryFn: fetchUserPreferences,
    enabled: !!sub,
    retry: false,
  });
};
